import { createElement } from '../../adapters/dom';
import { createStatusBadge } from '../components/status-badge';
import type { WidgetPaymentStatusResponse } from '../../types/state';

function normalizeCode(value: string | null | undefined): string {
  return (value || '').trim().toUpperCase();
}

function buildExplorerTxUrl(network: string | null | undefined, txHash: string): string | null {
  const networkCode = normalizeCode(network);

  if (!txHash) {
    return null;
  }

  if (networkCode === 'TRON') {
    return `https://tronscan.org/#/transaction/${encodeURIComponent(txHash)}`;
  }

  if (networkCode === 'ETHEREUM') {
    return `https://etherscan.io/tx/${encodeURIComponent(txHash)}`;
  }

  if (networkCode === 'SOLANA') {
    return `https://solscan.io/tx/${encodeURIComponent(txHash)}`;
  }

  return null;
}

function formatSuccessAmount(value: string | number | null | undefined, asset: string | null | undefined): string {
  if (value === null || value === undefined || value === '') {
    return '—';
  }

  const assetCode = normalizeCode(asset);
  const numeric = Number(value);

  if (!Number.isFinite(numeric)) {
    return assetCode ? `${value} ${assetCode}` : String(value);
  }

  if (assetCode === 'USDT' || assetCode === 'USDC') {
    return `${numeric.toFixed(2)} ${assetCode}`;
  }

  return assetCode
    ? `${numeric.toFixed(8).replace(/\.?0+$/, '')} ${assetCode}`
    : numeric.toFixed(8).replace(/\.?0+$/, '');
}

function shortenTxHash(txHash: string): string {
  if (txHash.length <= 22) {
    return txHash;
  }

  return `${txHash.slice(0, 10)}...${txHash.slice(-10)}`;
}

export function createSuccessTemplate(status: WidgetPaymentStatusResponse): HTMLDivElement {
  const wrapper = createElement('div', {
    className: 'cpw-screen cpw-screen-success'
  }) as HTMLDivElement;

  const badge = createStatusBadge('success');

  const title = createElement('h3', {
    className: 'cpw-title',
    textContent: 'Оплата прошла успешно'
  });

  const description = createElement('p', {
    className: 'cpw-text',
    textContent: `Получено ${formatSuccessAmount(status.receivedAmount, status.asset)}`
  });

  wrapper.append(badge, title, description);

  const txHash = status.txHashes?.[0] || '';
  const explorerUrl = buildExplorerTxUrl(status.network, txHash);

  if (txHash && explorerUrl) {
    const txBlock = createElement('div', {
      className: 'cpw-success-tx'
    }) as HTMLDivElement;

    const txLabel = createElement('div', {
      className: 'cpw-success-tx-label',
      textContent: 'Транзакция'
    });

    const txLink = createElement('a', {
      className: 'cpw-success-tx-link',
      textContent: `Открыть в обозревателе · ${shortenTxHash(txHash)}`,
      attributes: {
        href: explorerUrl,
        target: '_blank',
        rel: 'noopener noreferrer'
      }
    }) as HTMLAnchorElement;

    txBlock.append(txLabel, txLink);
    wrapper.append(txBlock);
  }

  return wrapper;
}